import { HttpClient } from '../../httpClient'
import type { OpalApiResponseDocument } from '../../schema'

type ReadReactionsV2ResponseDocument = OpalApiResponseDocument<
  'ReadReactionTypesV2',
  200
>

export const readReactions = (): Promise<ReadReactionsV2ResponseDocument> => {
  const url = new URL('reactions/v2/reaction_types', window.location.origin)

  return HttpClient()
    .get(url.toString())
    .then((res) => res.data)
}
